var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('VFooter')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-box"},[_c('p',{staticClass:"p1"},[_vm._v("\n      敬請期待~\n    ")]),_c('div',{staticClass:"c-flex-space-center"})])
}]

export { render, staticRenderFns }